namespace TabAurous.Sales {
    export namespace SalesApprovalItemsService {
        export const baseUrl = 'Sales/SalesApprovalItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalOutItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/SalesApprovalItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>SalesApprovalItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
